module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-config fl p-l-20 border-box",
    style: ('width:' + _vm.width + ';height:' + _vm.height)
  }, [_c('div', {
    staticClass: "bor-deep-gra bg-wh h-100p ovf-auto"
  }, [_c('p', {
    staticClass: " ft-bold p-t-20 p-b-20 m-t-0 m-b-0 m-l-30 m-r-30 bor-b-gray"
  }, [_vm._v("配置项")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-20 p-l-30 p-r-30"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curNode,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "节点名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curNode.name),
      expression: "curNode.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-230",
    domProps: {
      "value": (_vm.curNode.name)
    },
    on: {
      "input": function($event) {
        _vm.curNode.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curNode.type != _vm.TYPE_REMARK),
      expression: "curNode.type != TYPE_REMARK"
    }],
    attrs: {
      "label": "节点描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curNode.description),
      expression: "curNode.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-230",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.curNode.description)
    },
    on: {
      "input": function($event) {
        _vm.curNode.description = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.nodeMission || _vm.nodeApprove) ? _c('receiver-config', {
    attrs: {
      "title": "接收方",
      "data": _vm.curNode,
      "users": _vm.users,
      "groups": _vm.groups,
      "structs": _vm.structs,
      "inputList": _vm.inputList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nodeApprove) ? _c('form-block', {
    attrs: {
      "title": "回退配置"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回退人配置"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.rollback_config),
      expression: "curNode.rollback_config"
    }],
    domProps: {
      "value": (_vm.curNode.rollback_config)
    },
    on: {
      "input": function($event) {
        _vm.curNode.rollback_config = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("上一级处理人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("发起人")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回退字段名称"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.rollback_dialog_config.title),
      expression: "curNode.rollback_dialog_config.title"
    }],
    staticClass: "w-300",
    domProps: {
      "value": (_vm.curNode.rollback_dialog_config.title)
    },
    on: {
      "input": function($event) {
        _vm.curNode.rollback_dialog_config.title = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认值"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.rollback_dialog_config.placeholder),
      expression: "curNode.rollback_dialog_config.placeholder"
    }],
    staticClass: "w-300",
    domProps: {
      "value": (_vm.curNode.rollback_dialog_config.placeholder)
    },
    on: {
      "input": function($event) {
        _vm.curNode.rollback_dialog_config.placeholder = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否必填"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.rollback_dialog_config.allowEmpty),
      expression: "curNode.rollback_dialog_config.allowEmpty"
    }],
    domProps: {
      "value": (_vm.curNode.rollback_dialog_config.allowEmpty)
    },
    on: {
      "input": function($event) {
        _vm.curNode.rollback_dialog_config.allowEmpty = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])])]) : _vm._e(), _vm._v(" "), (_vm.nodeMission || _vm.nodeApprove) ? _c('form-block', {
    attrs: {
      "title": "知会配置"
    }
  }, [(_vm.nodeMission || _vm.nodeApprove) ? _c('receiver-config', {
    attrs: {
      "title": "知会方",
      "data": _vm.curNode.notify_config,
      "users": _vm.users,
      "groups": _vm.groups,
      "structs": _vm.structs,
      "inputList": _vm.inputList
    }
  }, [_c('template', {
    slot: "presentType"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不知会")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否重置消息通知"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.notify_config.is_reset_notify),
      expression: "curNode.notify_config.is_reset_notify"
    }],
    domProps: {
      "value": (_vm.curNode.notify_config.is_reset_notify)
    },
    on: {
      "input": function($event) {
        _vm.curNode.notify_config.is_reset_notify = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), (_vm.curNode.notify_config.is_reset_notify == 1) ? [_c('el-form-item', {
    attrs: {
      "label": "消息标题"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.notify_config.msg_title),
      expression: "curNode.notify_config.msg_title"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.curNode.notify_config.msg_title)
    },
    on: {
      "input": function($event) {
        _vm.curNode.notify_config.msg_title = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息内容"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.notify_config.msg_content),
      expression: "curNode.notify_config.msg_content"
    }],
    staticClass: "w-200",
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.curNode.notify_config.msg_content)
    },
    on: {
      "input": function($event) {
        _vm.curNode.notify_config.msg_content = $event
      }
    }
  })])] : _vm._e()], true) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.nodeApprove) ? _c('form-block', {
    attrs: {
      "title": "审批历史配置"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通过字段名称"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.pass_dialog_config.title),
      expression: "curNode.pass_dialog_config.title"
    }],
    staticClass: "w-300",
    domProps: {
      "value": (_vm.curNode.pass_dialog_config.title)
    },
    on: {
      "input": function($event) {
        _vm.curNode.pass_dialog_config.title = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认值"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.pass_dialog_config.placeholder),
      expression: "curNode.pass_dialog_config.placeholder"
    }],
    staticClass: "w-300",
    domProps: {
      "value": (_vm.curNode.pass_dialog_config.placeholder)
    },
    on: {
      "input": function($event) {
        _vm.curNode.pass_dialog_config.placeholder = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否必填"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.pass_dialog_config.allowEmpty),
      expression: "curNode.pass_dialog_config.allowEmpty"
    }],
    domProps: {
      "value": (_vm.curNode.pass_dialog_config.allowEmpty)
    },
    on: {
      "input": function($event) {
        _vm.curNode.pass_dialog_config.allowEmpty = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nodeOnly),
      expression: "nodeOnly"
    }]
  }, [_c('div', {
    staticClass: "el-form-item__label"
  }, [_vm._v("配置判断变量")]), _vm._v(" "), _c('el-table', {
    staticClass: "m-b-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.curNode.variable
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [(!scope.row.isClone) ? _c('el-button', {
          staticClass: "m-l-5",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.cloneVar(scope.row, scope.$index)
            }
          }
        }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (!scope.row.isClone) ? _c('el-button', {
          staticClass: "m-l-5",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.sortVarUp(scope.row, scope.$index)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (!scope.row.isClone) ? _c('el-button', {
          staticClass: "m-l-5",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.sortVarDown(scope.row, scope.$index)
            }
          }
        }, [_vm._v("下移")]) : _c('el-button', {
          staticClass: "m-l-5",
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.removeVar(scope.row, scope.$index)
            }
          }
        }, [_vm._v("-")]), _vm._v(" ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流向",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.filterNodeName(scope.row.next_iden)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "默认流向",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [(!scope.row.isClone) ? _c('el-radio-group', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.is_default),
            expression: "scope.row.is_default"
          }],
          domProps: {
            "value": (scope.row.is_default)
          },
          on: {
            "change": function($event) {
              _vm.resetIsDefault(scope.row, scope.$index)
            },
            "input": function($event) {
              scope.row.is_default = $event
            }
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v(" ")])]) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "选取变量",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.field_id),
            expression: "scope.row.field_id"
          }],
          attrs: {
            "placeholder": "请选择判断变量"
          },
          domProps: {
            "value": (scope.row.field_id)
          },
          on: {
            "input": function($event) {
              scope.row.field_id = $event
            }
          }
        }, _vm._l((_vm.inputList), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.default.title,
              "value": item.default.field_id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "逻辑",
      "prop": "logic_type",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.logic_type),
            expression: "scope.row.logic_type"
          }],
          attrs: {
            "placeholder": "请选择判断逻辑"
          },
          domProps: {
            "value": (scope.row.logic_type)
          },
          on: {
            "input": function($event) {
              scope.row.logic_type = $event
            }
          }
        }, _vm._l((_vm.logics), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "选取变量或值",
      "width": "150px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticClass: "el-input__inner pointer",
          staticStyle: {
            "line-height": "28px"
          },
          on: {
            "click": function($event) {
              _vm.showVar(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.filterInputTitle(scope.row, scope.row.fixed_value)))])]
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nodeApprove),
      expression: "nodeApprove"
    }],
    attrs: {
      "label": "审批规则",
      "prop": "examine_rule"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curNode.examine_rule),
      expression: "curNode.examine_rule"
    }],
    domProps: {
      "value": (_vm.curNode.examine_rule)
    },
    on: {
      "input": function($event) {
        _vm.curNode.examine_rule = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("必须节点上所有审批人员审批方可通过")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("只需节点上任意一人审批即可通过")])])])])])]), _vm._v(" "), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.varShow),
      expression: "varShow"
    }],
    attrs: {
      "title": "选择变量",
      "size": "tiny"
    },
    domProps: {
      "value": (_vm.varShow)
    },
    on: {
      "input": function($event) {
        _vm.varShow = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('div', {
    staticClass: "inline-block w-100"
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curVar.value_type),
      expression: "curVar.value_type"
    }],
    attrs: {
      "label": 10
    },
    domProps: {
      "value": (_vm.curVar.value_type)
    },
    on: {
      "input": function($event) {
        _vm.curVar.value_type = $event
      }
    }
  }, [_vm._v("固定值")])]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempVar.fixed_value),
      expression: "tempVar.fixed_value"
    }],
    staticClass: "w-200",
    attrs: {
      "disabled": _vm.curVar.value_type != 10
    },
    domProps: {
      "value": (_vm.tempVar.fixed_value)
    },
    on: {
      "input": function($event) {
        _vm.tempVar.fixed_value = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "inline-block w-100"
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curVar.value_type),
      expression: "curVar.value_type"
    }],
    attrs: {
      "label": 20
    },
    domProps: {
      "value": (_vm.curVar.value_type)
    },
    on: {
      "input": function($event) {
        _vm.curVar.value_type = $event
      }
    }
  }, [_vm._v("变量")])]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempVar.field_id),
      expression: "tempVar.field_id"
    }],
    attrs: {
      "disabled": _vm.curVar.value_type != 20
    },
    domProps: {
      "value": (_vm.tempVar.field_id)
    },
    on: {
      "input": function($event) {
        _vm.tempVar.field_id = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.title,
        "value": item.default.field_id
      }
    })
  }))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.varShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectVar
    }
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b4d4b13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/nodeConfig.vue
// module id = 1805
// module chunks = 2